import "./polyfills";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import * as Sentry from "@sentry/react";
import App from "./App";
import { useThemeStore } from "./stores/themeStore";
import { registerServiceWorker } from "./pwa";
import "./index.css";

// Must run before render: `beforeinstallprompt` fires early and isn't replayed,
// so importing this module installs the listener that parks it for the install
// banner. Registering the worker is what makes the event fire at all.
registerServiceWorker();

// Reconcile the theme class (the no-FOUC inline script in index.html set it
// on first paint) and bind the OS-preference listener before we render, so
// every surface — login, onboarding, shell — themes consistently.
useThemeStore.getState().init();

// Initialize Sentry for frontend error tracking.
// Uses the same self-hosted Sentry instance as the backend.
Sentry.init({
  dsn: "https://ee2177dde853744b7f2011018f856f8e@sentry.corp.nbyula.com/38",
  environment: window.location.hostname === "127.0.0.1" ? "production" : "development",
  // Tag the release so frontend + backend errors correlate
  release: `nbyula-cowork-frontend@${__APP_VERSION__}`,
  integrations: [
    Sentry.browserTracingIntegration(),
  ],
  tracesSampleRate: 0.2,
  // Don't send in Vite dev mode (port 5173)
  enabled: !window.location.port || window.location.port !== "5173",
});

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <Sentry.ErrorBoundary fallback={<p style={{padding: 24}}>Something went wrong. Please restart the app.</p>}>
      <App />
    </Sentry.ErrorBoundary>
  </StrictMode>,
);
